/**
 * User session context and reducer (replaces caribe7/modules/auth/stores/user-session-store).
 */

import React from 'react';
import { isGuestSessionUser } from './sessionContract';

/** Minimal user shape for session context (storage/API may have more fields). */
export type UserSessionUser = {
  session_id?: string | null;
  player_id?: string | number | null;
  guest?: boolean;
  odds_format?: string;
  currency?: string;
  player_balance?: number;
  [key: string]: unknown;
};

export type UserSessionState = {
  user: UserSessionUser | null;
  session_id: string | true | null;
  error: unknown;
  flag: boolean;
};

const initialState: UserSessionState = {
  user: null,
  session_id: null,
  error: null,
  flag: true,
};

function userSessionReducer(
  state: UserSessionState,
  action: { type: string; payload?: unknown }
): UserSessionState {
  switch (action.type) {
    case 'SET_USER':
      return { ...state, user: action.payload as UserSessionUser | null };
    case 'REMOVE_USER':
      return { ...state, user: null };
    case 'SET_ERROR':
      return { ...state, error: action.payload };
    default:
      return state;
  }
}

export const UserSessionContext = React.createContext<[UserSessionState, React.Dispatch<{ type: string; payload?: unknown }>]>(
  [initialState, () => {}]
);

export const useUserSessionContext = () => React.useContext(UserSessionContext);

export function isGuestUserSession(user: UserSessionUser | null | undefined): boolean {
  return isGuestSessionUser(user);
}

export default function UserSessionStore({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = React.useReducer(userSessionReducer, initialState);
  return (
    <UserSessionContext.Provider value={[state, dispatch]}>
      {children}
    </UserSessionContext.Provider>
  );
}
